import React, { memo } from 'react';
import { Stack, Typography, Icon } from 'investira.react.components';
import { formats } from 'investira.sdk';
import { CARTEIRA_TIPO } from '../../../enums';

/**
 * Renderiza o componente SearchAddCarteiraItem.
 *
 * @param {Object} props - Propriedades do componente.
 * @param {*} props.data - Propriedade `data` do componente.
 * @param {*} props.onClick - Propriedade `onClick` do componente.
 *
 * @description
 * Este componente realiza as seguintes operacoes:
 * 1. Recebe as propriedades necessarias para compor a interface
 * 2. Organiza os estados e callbacks usados durante a renderizacao
 * 3. Renderiza a experiencia visual do organismo
 *
 * @returns {JSX.Element|null} Elemento renderizado pelo componente.
 */

const SearchAddCarteiraItem = memo(props => {
  const { data, onClick } = props;

  return (
    <Stack
      id={data.pessoa_id}
      key={data.pessoa_id}
      direction="row"
      spacing={3}
      alignItems="center"
      component="li"
      onClick={onClick}
      sx={{
        px: 2,
        py: 1,
        cursor: 'pointer',
        '&:hover': {
          color: 'gray',
          backgroundColor: 'background.main'
        }
      }}>
      <Stack>
        <Stack
          backgroundColor="primary.main"
          width="36px"
          height="36px"
          justifyContent="center"
          alignItems="center"
          borderRadius="8px">
          <Icon iconName={'wallet'} color="secondary" size={18} />
        </Stack>
      </Stack>
      <Stack flexGrow={1}>
        <Stack direction="row" spacing={{ xs: 0, sm: 1 }} justifyContent="space-between">
          <Stack>
            <Typography variant="body2" color="textPrimary">
              {data.carteira || data.carteira_seuid}
            </Typography>
            <Typography
              variant="caption"
              color="textSecondary"
              sx={{
                display: { xs: 'none', sm: 'inline-block' }
              }}>
              {`${data.carteira_seuid}`}
            </Typography>
          </Stack>
          <Stack alignItems="end">
            <Typography variant="caption" color="textSecondary">
              {data.data_posicao ? formats.formatDate(data.data_posicao) : 'Sem posição'}
            </Typography>
            <Typography variant="caption" color="textSecondary">
              {CARTEIRA_TIPO[data.carteira_tipo_id]?.label}
            </Typography>
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  );
});

export default SearchAddCarteiraItem;
